export const getSelect = state => state.enterprise.selecCompany;
export const getCompanies = state => state.enterprise.companies;

export default {
	getSelect,
	getCompanies,
};
